import { z } from 'zod';

export const FORM_SCHEMA = z.object({
  serviceable_days: z.coerce.number().min(1, 'Must be atleast 1 day')
});

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  serviceable_days: ''
};
